import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "checked", "className", "children", "dataset", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import parentStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Checkbox = _ref => {
  let {
    id: optionId,
    checked = false,
    className = '',
    children,
    dataset,
    onChange = () => null
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const inputEl = useRef(null); // Sync checked attribute to input

  useEffect(() => {
    if (!inputEl.current) return;
    const isChecked = Boolean(checked);
    const inputElement = inputEl.current;

    if (inputElement.checked !== isChecked) {
      inputElement.checked = isChecked;
    }
  }, [checked]);
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread(_objectSpread({}, dataset && _objectSpread({}, dataset)), optionId && {
    htmlFor: optionId
  }), {}, {
    className: clsx(parentStyles.optionsInputLabel, styles.label, className),
    children: [/*#__PURE__*/_jsx("aside", {
      className: parentStyles.optionsInputLabel__aside,
      children: /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, optionId && {
        id: optionId
      }), {}, {
        ref: inputEl,
        type: "checkbox",
        onChange: onChange,
        defaultChecked: Boolean(checked),
        className: styles.input
      }, props))
    }), /*#__PURE__*/_jsx("span", {
      className: parentStyles.optionsInputLabel__main,
      children: children
    })]
  }));
};

export default Checkbox;